<layout-sidebar>
  <div class="main">
    <section id="bill-account-contact">
      @if (!!(isContactBillingError | async)) {
        <ds-error-message [errorList]="errorList"></ds-error-message>
      }
      <div>
        <div class="column twelve">
          <h2
            class="heading-main"
            dsContent
            [contentPath]="'billing.contactBillingPageHeader'"
          ></h2>
          <div class="row pad-bottom-16">
            <p
              *dsPartnerAFI
              dsContent
              [contentPath]="'billing.contactBillingHelpTxtPart1Updated'"
              [options]="{
                amfamUrl: amfamDotCom + 'payments/online-billing'
              }"
            ></p>
            <p
              *dsPartnerConnect
              dsContent
              [contentPath]="'billing.contactBillingHelpTxtPart1UpdatedPartner'"
            ></p>

            <div
              *dsPartnerAFI
              dsContent
              [contentPath]="'billing.contactBillingHelpTxtPart2Updated'"
              [options]="{
                amfamPrivacyUrl: amfamDotCom + 'privacy-security',
                custCareNum: amfamCustomerCareNumber
              }"
            ></div>
            <div
              *dsPartnerConnect
              dsContent
              [contentPath]="'billing.contactBillingHelpTxtPart2UpdatedPartner'"
              [options]="{
                custCareNum: partnerCustomerCareNumber
              }"
              [dsRouterLink]="['/privacy-security-policy']"
            ></div>
          </div>

          <form [formGroup]="contactBillingForm" (ngSubmit)="submit()">
            <fieldset class="row pad-bottom-16">
              <legend
                dsContent
                [contentPath]="'billing.contactBillingNameHelpTxt'"
                class="pad-vertical-10"
              ></legend>
              <div class="column twelve pad-bottom-10 md-six md-pad-right-10 md-pad-bottom-0">
                <ds-form-control-container
                  labelText="First Name"
                  [control]="contactBillingForm.get('firstNameInput')"
                >
                  <input
                    type="text"
                    id="firstNameInput"
                    class="fill"
                    formControlName="firstNameInput"
                  />
                  <ds-form-control-message [control]="contactBillingForm.get('firstNameInput')">
                  </ds-form-control-message>
                </ds-form-control-container>
              </div>

              <div class="column twelve md-six">
                <ds-form-control-container
                  labelText="Last Name"
                  [control]="contactBillingForm.get('lastNameInput')"
                >
                  <input
                    type="text"
                    id="lastNameInput"
                    class="fill"
                    formControlName="lastNameInput"
                  />
                  <ds-form-control-message [control]="contactBillingForm.get('lastNameInput')">
                  </ds-form-control-message>
                </ds-form-control-container>
              </div>
            </fieldset>

            <fieldset class="row pad-bottom-16">
              <legend
                dsContent
                [contentPath]="'billing.contactBillingReasonHelpTxt'"
                class="pad-vertical-10"
              ></legend>
              <div class="column twelve md-six md-pad-right-10">
                <ds-form-control-container
                  labelText="Describe the issue"
                  [control]="contactBillingForm.get('contactReasons')"
                >
                  <select
                    id="contactReasons"
                    class="icon fill"
                    (change)="onContactReasonChange($event.target.value)"
                    formControlName="contactReasons"
                  >
                    <option value=""></option>
                    @for (reasonOfContact of contactReasons; track reasonOfContact) {
                      <option [value]="reasonOfContact">
                        {{ reasonOfContact }}
                      </option>
                    }
                  </select>
                  <span class="icon-chevron-down"></span>
                </ds-form-control-container>
              </div>
            </fieldset>

            <fieldset class="row pad-bottom-16">
              <legend
                dsContent
                [contentPath]="'billing.contactBillingContactModeHelpTxt'"
                class="pad-vertical-10"
              ></legend>
              <div class="column twelve md-six md-pad-right-10">
                <ds-form-control-container
                  labelText="Contact method"
                  [control]="contactBillingForm.get('contactMode')"
                >
                  <select
                    id="contactMode"
                    class="icon fill"
                    (change)="onContactModeChange($event.target.value)"
                    formControlName="contactMode"
                  >
                    <option value=""></option>
                    @for (methodOfContact of contactMode; track methodOfContact) {
                      <option [value]="methodOfContact">
                        {{ methodOfContact }}
                      </option>
                    }
                  </select>
                  <span class="icon-chevron-down"></span>
                  <ds-form-control-message [control]="contactBillingForm.get('contactMode')">
                  </ds-form-control-message>
                </ds-form-control-container>
              </div>
            </fieldset>

            @if (currentContactMode == 'Email') {
              <fieldset class="row pad-bottom-16">
                <legend
                  dsContent
                  [contentPath]="'billing.contactBillingEmailHelpTxt'"
                  class="pad-vertical-10"
                ></legend>
                <div class="column twelve md-six md-pad-right-10">
                  <ds-form-control-container
                    labelText="Email Address"
                    [control]="contactBillingForm.get('emailInput')"
                  >
                    <input type="text" id="emailInput" class="fill" formControlName="emailInput" />
                    <ds-form-control-message
                      [control]="contactBillingForm.get('emailInput')"
                    ></ds-form-control-message>
                  </ds-form-control-container>
                </div>
              </fieldset>
            }
            @if (currentContactMode == 'Phone' && phoneList && phoneList.length == 0) {
              <fieldset class="row pad-bottom-16">
                <legend
                  dsContent
                  [contentPath]="'billing.contactBillingPhoneHelpTxt'"
                  class="pad-vertical-10"
                ></legend>
                <div class="column twelve md-six md-pad-right-10">
                  <ds-form-control-container
                    labelText="Phone Number"
                    [control]="contactBillingForm.get('phoneInput')"
                  >
                    <input
                      [identifier]="'phoneInput'"
                      id="phoneInput"
                      [preValue]="contactBillingForm.value.phoneInput"
                      [phoneControl]="contactBillingForm.controls['phoneInput']"
                      formControlName="phoneInput"
                      maxlength="12"
                      dsPhoneMask
                    />
                    <ds-form-control-message
                      [control]="contactBillingForm.get('phoneInput')"
                    ></ds-form-control-message>
                  </ds-form-control-container>
                </div>
              </fieldset>
            }
            @if (currentContactMode == 'Phone' && phoneList && phoneList.length > 0) {
              <fieldset class="row pad-bottom-16">
                <div class="column twelve md-six md-pad-right-10">
                  <legend
                    dsContent
                    [contentPath]="'billing.contactBillingPhoneHelpTxt'"
                    class="pad-vertical-10"
                  ></legend>
                  <ds-form-control-container
                    labelText="Phone Number"
                    [control]="contactBillingForm.get('phoneInputList')"
                  >
                    <select id="phoneInputList" class="icon fill" formControlName="phoneInputList">
                      <option value=""></option>
                      @for (phoneNum of phoneList; track phoneNum) {
                        <option [value]="phoneNum">
                          {{ phoneNum }}
                        </option>
                      }
                    </select>
                    <span class="icon-chevron-down"></span>
                    <ds-form-control-message [control]="contactBillingForm.get('phoneInputList')">
                    </ds-form-control-message>
                  </ds-form-control-container>
                </div>
              </fieldset>
            }

            <fieldset class="row pad-bottom-16">
              <legend
                dsContent
                [contentPath]="'billing.contactBillingAccountHelpTxt'"
                class="pad-vertical-10"
              ></legend>
              <div class="column twelve md-six md-pad-right-10">
                <ds-form-control-container
                  labelText="Please choose all that apply"
                  [control]="contactBillingForm.get('billingAcctNumberInput')"
                >
                  <select
                    id="billingAcctNumberInput"
                    class="icon fill"
                    formControlName="billingAcctNumberInput"
                  >
                    <option value=""></option>
                    @for (billAcc of billAccounts; track billAcc) {
                      <option [value]="billAcc.billAccountNumber">
                        @if (!!billAcc?.billingPreferences?.accountNickName) {
                          <span>{{ billAcc.billingPreferences.accountNickName }}</span>
                        }
                        @if (!billAcc?.billingPreferences?.accountNickName) {
                          <span>{{ billAcc.billAccountNumber | prettyBillingAcctNum }}</span>
                        }
                      </option>
                    }
                  </select>
                  <span class="icon-chevron-down"></span>
                  <!--
                  <input type="text" id="billingAcctNumberInput" class="fill" formControlName="billingAcctNumberInput">
                  -->
                  <ds-form-control-message
                    [control]="contactBillingForm.get('billingAcctNumberInput')"
                  >
                  </ds-form-control-message>
                </ds-form-control-container>
              </div>
            </fieldset>

            <fieldset class="row pad-bottom-16">
              <legend
                dsContent
                [contentPath]="'billing.contactBillingCommentsHelpTxt'"
                class="pad-vertical-10"
              ></legend>
              <div class="column twelve">
                <ds-form-control-container
                  labelText="Comments"
                  [control]="contactBillingForm.get('messageInput')"
                >
                  <textarea
                    id="messageInput"
                    class="fill"
                    formControlName="messageInput"
                    rows="3"
                    maxlength="250"
                    spellcheck="true"
                  ></textarea>
                  <ds-form-control-message
                    [control]="contactBillingForm.get('messageInput')"
                  ></ds-form-control-message>
                </ds-form-control-container>
              </div>
              <p
                *dsPartnerAFI
                dsContent
                [contentPath]="'billing.contactBillingFormNoteHelpTxt'"
              ></p>
              <p
                *dsPartnerConnect
                dsContent
                [contentPath]="'billing.contactBillingFormNoteHelpTxtPartners'"
              ></p>
            </fieldset>

            <div class="row flex pad-top-20">
              <div>
                <button
                  ds-button
                  class="-outline float-left"
                  type="submit"
                  [disabled]="
                    !contactBillingForm.valid ||
                    !(roleService.isAuthorized('submitcontactbillingfrm') | async)
                  "
                  aria-label="Submit"
                >
                  Submit
                </button>
              </div>
              <div class="margin-left-20">
                <p
                  dsContent
                  class="column twelve float-left"
                  [contentPath]="'billing.contactBillingFormSubmitHelpTxt'"
                ></p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
  <aside class="main-aside">
    <links-agents-sidebar [quickLinksList]="quickLinks"></links-agents-sidebar>
  </aside>
</layout-sidebar>
